import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { QueryResult } from "../model/query.filter.class";
import { createUrl } from "./api.util";

export interface ConfigGeneral {
  id: number;
  name: string;
  value: string;
  description?: string;
}

@Injectable({
  providedIn: "root",
})
export class ConfigGeneralApi {
  public path = "config-general";

  constructor(public httpClient: HttpClient) {}

  /**
   * Get all config-general values
   * Returns a QueryResult with rows array
   */
  getAll = (): Observable<QueryResult<ConfigGeneral>> => {
    return this.httpClient.get<QueryResult<ConfigGeneral>>(createUrl(this.path));
  };

  /**
   * Get a specific config by name
   */
  getByName = (name: string): Observable<ConfigGeneral> => {
    return this.httpClient.get<ConfigGeneral>(createUrl(this.path, "by-name", name));
  };
}
